<template>
<div>
    <vue-headful
      title="Photo Challenge"
      description="Take your five senses on an Alabama photo hunt"
      url="https://alabama.travel/photo-challenge"/>
    <section>
      <Banner :banners="banners" :showBanner="false"/>
      <div class="banner-logo"><img :src="page.fields.banner_logo" :alt="page.fields.banner_logo_alt_text" role="presentation"/></div>
      <div class="container">
    <div class="row justify-content-md-center">
        <div class="col-lg-8 mt-5">
          <h1>{{page.fields.title}}</h1>
          <p class="description">{{page.fields.description}}</p>
        </div>
        </div>
      </div>
        <div class="container-fluid">
        <div class="row align-items-center">
          <div class="col-lg-7 mt-5">
            <img src="/images/scavenger-hunt/scavenger-top.svg" class="img-fluid grand-wrapper"  role="presentation"/>
            <h1>{{page.fields.grand_prize_heading}}</h1>
            <div class="grand-prize-description" v-html="page.fields.grand_prize_description"></div>
            <div><a href="#requirements">See Requirements</a></div>
            <img src="/images/scavenger-hunt/scavenger-bottom.svg" class="img-fluid grand-wrapper" alt="" role="presentation"/>
          </div>
          <div class="col-lg-4 mt-5"><img :src="page.fields.grand_prize_image" class="img-fluid" :alt="page.fields.grand_prize_image_alt_text" role="presentation"/></div>
        </div>
        </div>
        <div class="container-fluid">
        <div class="row justify-content-md-center">
          <div class="col-lg-12 mt-5">
            <h2>{{page.fields.see_whats_being_posted}}</h2>
            <p> {{page.fields.see_whats_being_posted_description}}</p>
          </div>
        </div>
    </div>
    <div class="container-fluid">
      <div class="row justify-content-md-center">
        <div class="col-lg-2 sense-wrapper" @keyup.enter="senseSelected = 'sight'" @click="senseSelected = 'sight'" tabindex="0">
          <div class="outer-div">
            <video autoplay muted loop src="/videos/photo_challenge/Sight.mp4" class="img-fluid"/>
          </div>
          <h3>{{page.fields.hashtag_sight}}</h3>
        </div>
        <div class="col-lg-2 sense-wrapper" @keyup.enter="senseSelected = 'scent'" @click="senseSelected = 'scent'" tabindex="0">
          <div class="outer-div">
            <video autoplay muted loop src="/videos/photo_challenge/Scent.mp4" class="img-fluid"/>
          </div>
          <h3>{{page.fields.hashtag_scent}}</h3>
          </div>
        <div class="col-lg-2 sense-wrapper" @keyup.enter="senseSelected = 'taste'" @click="senseSelected = 'taste'" tabindex="0">
          <div class="outer-div">
              <video autoplay muted loop src="/videos/photo_challenge/Taste.mp4" class="img-fluid"/>
          </div>
          <h3>{{page.fields.hashtag_taste}}</h3>
        </div>
        <div class="col-lg-2 sense-wrapper" @keyup.enter="senseSelected = 'sound'" @click="senseSelected = 'sound'" tabindex="0">
          <div class="outer-div">
              <video autoplay muted loop src="/videos/photo_challenge/Sound.mp4" class="img-fluid"/>
          </div>
          <h3>{{page.fields.hashtag_sound}}</h3>
        </div>
        <div class="col-lg-2 sense-wrapper" @keyup.enter="senseSelected = 'feel'" @click="senseSelected = 'feel'" tabindex="0">
          <div class="outer-div">
              <video autoplay muted loop src="/videos/photo_challenge/Feeling.mp4" class="img-fluid"/>
          </div>
          <h3>{{page.fields.hashtag_feel}}</h3>
        </div>
      </div>
      </div>
      <div class="" v-if="senseSelected">
          <div class="mt-5 remove-pd" v-show="senseSelected == 'sight'">
            <h2>{{page.fields.hashtag_sight}}</h2>
            <Crowdriff
              :id="page.fields.crowdriff.sightcrowdriffid"
              :ariaLabel="page.fields.crowdriff.aria_label"
            />
          </div>

          <div class="mt-5 remove-pd" v-show="senseSelected == 'scent'">
            <h2>{{page.fields.hashtag_scent}}</h2>
            <Crowdriff
              :id="page.fields.crowdriff.scentcrowdriffid"
              :ariaLabel="page.fields.crowdriff.aria_label"
            />
          </div>

        <div class="mt-5 remove-pd" v-show="senseSelected == 'taste'">
          <h2>{{page.fields.hashtag_taste}}</h2>
          <Crowdriff
            :id="page.fields.crowdriff.tastecrowdriffid"
            :ariaLabel="page.fields.crowdriff.aria_label"
          />
        </div>

        <div class="mt-5 remove-pd" v-show="senseSelected == 'sound'">
          <h2>{{page.fields.hashtag_sound}}</h2>
          <Crowdriff
            :id="page.fields.crowdriff.soundcrowdriffid"
            :ariaLabel="page.fields.crowdriff.aria_label"
          />
        </div>

        <div class="mt-5 remove-pd" v-show="senseSelected == 'feel'">
          <h2>{{page.fields.hashtag_feel}}</h2>
          <Crowdriff
            :id="page.fields.crowdriff.feelingcrowdriffid"
            :ariaLabel="page.fields.crowdriff.aria_label"
          />
        </div>
      </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12 mt-5" id="requirements">
          <h2>{{page.fields.requirements_heading}}</h2>
        </div>
        <div class="col-lg-6 mt-5 text-left">
          <div v-html="page.fields.requirements_left_column"></div>
        </div>
        <div class="col-lg-6 mt-5 text-left">
          <div v-html="page.fields.requirements_right_column"></div>
        </div>
      </div>
    </div>
    </section>
    <Footer/>
    </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import Butter from 'buttercms';
import Footer from '@/components/Common/Footer.vue';
import Crowdriff from '@/components/Common/Crowdriff.vue';
import Banner from '@/components/Common/Banner.vue';

export const butter = Butter('eb418357164849860c223876bb84811162582149');

@Component({
  data() {
    return {
      banners: [],
      senseSelected: null,
      page: {
        fields: {},
      },
    };
  },
  components: {
    Footer,
    Banner,
    Crowdriff,
  },
  methods: {
    getPage() {
      butter.page.retrieve('*', 'photo-challenge', { preview: `${process.env.VUE_APP_BUTTER_PREVIEW}` })
        .then((res) => {
          this.page = res.data.data;
          this.banners = this.page.fields.slider_images;
        }).catch((res) => {
          console.log(res);
        });
    },
    getRandomSense() {
      const senseArray = ['sight', 'taste', 'scent', 'feel', 'sound'];
      this.$nextTick(() => {
        this.senseSelected = senseArray[Math.floor(Math.random() * senseArray.length)];
      });
    },
  },
  async created() {
    this.senseSelected = this.getRandomSense();
    this.getPage();
  },
})
class ScavengerHunt extends Vue {

}

export default ScavengerHunt;
</script>

<style scoped>
.description{
  padding-top: 30px;
  line-height: 30px;
}
.grand-wrapper {
    padding-left: 250px;
    padding-right: 250px;
    padding-top:20px;
    padding-bottom:20px;
}
.grand-prize-description {
  padding-left:250px;
  padding-right:250px;
  line-height: 30px;
}
.outer-div {
     overflow: hidden;
    display: inline-block;
     overflow: hidden;
     position: relative;
}
.sense-wrapper:hover {
  cursor: pointer;
  text-decoration: underline;
}
.sense-icon {
    position: absolute;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 120px;
    transition: all 0.5s ease;
    z-index: 2;
    width:100%;
    height:100%;
}
.inner-div {
     background-size: cover;
     background-position: center;
     transition: all 0.5s ease;
     position:absolute;
}
.banner-logo {
  position: absolute;
  z-index: 2;
  top:150px;
  margin: 0 auto;
  width:100%;
}
.banner-logo img {
  width: 500px;
}
.remove-pd >>> section.mt-5 {
  margin-top:0px!important;
}
 @media only screen and (max-width: 1600px) {
.banner-logo {
  top: 120px;
}
.grand-wrapper {
    padding-left: 180px;
    padding-right: 180px;
}
.grand-prize-description {
  padding-left:180px;
  padding-right:180px;
}
}
 @media only screen and (max-width: 1400px) {
.banner-logo {
  top: 80px;
}
.grand-wrapper {
    padding-left: 130px;
    padding-right: 130px;
}
.grand-prize-description {
  padding-left:130px;
  padding-right:130px;
}
}
 @media only screen and (max-width: 1200px) {
.banner-logo img {
  width: 450px;
}
.banner-logo {
  top: 50px;
}
.grand-wrapper {
    padding-left: 100px;
    padding-right: 100px;
}
.grand-prize-description {
  padding-left:100px;
  padding-right:100px;
}
}
 @media only screen and (max-width: 1024px) {
.banner-logo img {
  width: 400px;
}
}
 @media only screen and (max-width: 900px) {

.banner-logo {
  position: absolute;
  z-index: 2;
  top:30px;
  margin: 0 auto;
  width:100%;
}
.banner-logo img {
  width: 350px;
}
.grand-wrapper {
    padding-left: 10px;
    padding-right: 10px;
}
.grand-prize-description {
  padding-left:10px;
  padding-right:10px;
}
}
 @media only screen and (max-width: 768px) {
   .grand-prize-description {
  padding-left:0px;
  padding-right:0px;
  line-height: 30px;
}
.banner-logo {
  position: absolute;
  z-index: 2;
  top:20px;
  margin: 0 auto;
  width:100%;
}
.banner-logo img {
  width: 180px;
}
}
</style>
